import * as RoutePathConstants from "../../../../../../constants/RoutePathConstants";
import { API_BASE_URL } from "../../../../../../common/utils/commonUrl";
import http from "../../../../../../common/utils/http";

export default {
  data () {
    return {
      memberDetails: null
    };
  },
  methods: {
    goToShopptingCard () {
      this.$router.push({
        path: RoutePathConstants.POINTS_MAIL_HOME_PAGE
      });
    },
    goToMemberCenter () {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_CENTER
      });
    },
    goToTestDrive () {
      this.$router.push({
        path: RoutePathConstants.TEST_DRIVE
      });
    },
    gotoVeentDetails () {
      this.$router.push({
        path: RoutePathConstants.VEENT_DETAILS
      });
    },
    goToDiscountDetails () {
      this.$router.push({
        path: RoutePathConstants.DISCOUNT_DETAILS
      });
    },
    goToPracticalSkillsDetails () {
      this.$router.push({
        path: RoutePathConstants.PRACTICAL_SKILLS_DETAILS
      });
    },
    goToMakeAnAppointment (reservationType) {
      this.$router.push({
        path: RoutePathConstants.MAKE_AN_APPOINTMENT,
        query: {
          reservationType: reservationType
        }
      });
    },
    goToPageMailService () {
      this.$router.push({
        path: RoutePathConstants.PAGE_MAIL_SERVICE
      });
    },
    goToNewHomw () {
      this.$router.push({
        path: RoutePathConstants.NEW_HOUME_PAGE
      });
    },
    goToOneClickRenewal () {
      this.$router.push({
        path: RoutePathConstants.ONE_CLICK_RENEWAL
      });
    },
    goToAnnualInspectionAgency () {
      this.$router.push({
        path: RoutePathConstants.ANNUAL_INSPECTION_AGENCY
      });
    },
    qoToOilCardRecharge () {
      this.$router.push({
        path: RoutePathConstants.OIL_CARD_RECHARGE
      });
    },
    goToFinancialService () {
      this.$router.push({
        path: RoutePathConstants.FINANCIAL_SERVICE
      });
    },
    goToCarWashService () {
      this.$router.push({
        path: RoutePathConstants.CAR_WASH_SERVICE
      });
    },
    goToMyCarServe () {
      this.$router.push({
        path: RoutePathConstants.MY_CAR_SERVE
      });
    },
    goToExtendedInsurance () {
      this.$router.push({
        path: RoutePathConstants.EXTENDED_INSURANCE
      });
    },
    // 个人信息
    getMemberDetails () {
      http
        .get(`${API_BASE_URL}/api/wxoa/member/member/getUserMemberDetails`)
        .then(res => {
          this.memberDetails = res.data.data;
        });
    }
  },
  mounted () {
    this.getMemberDetails();
  }
};



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-service/views/page-mail-service/page-mail-service.js